var Getter = require('./abstract/getter');

module.exports = Template;

function Template () {}
Template.prototype = new Getter();
Template.prototype.constructor = Template;

Template.prototype.initialize = function () {
  this.editor = INKIVE.Tool.getInstance().editor;
  this.canvas = this.editor.canvas;

  this.structure = {
    'size': { 'width': null, 'height': null },
    'format': { 'id': null },
    'grid': { 'index_in_set': null, 'number_of_photos': null },
    'designed': { 'id': null },
    'restricted': { 'base_page': null }
  };
};

Template.prototype.get = function (attributeChain1, attributeChain2) {
  return attributeChain2
    ? Getter.prototype.get.call(this, attributeChain1, attributeChain2)
    : Getter.prototype.get.call(this, $('#svgcontent')[0], attributeChain1);
};

Template.prototype.getSizeWidth = function () {
  return this.canvas.contentW;
};

Template.prototype.getSizeHeight = function () {
  return this.canvas.contentH;
};

Template.prototype.getDesignedId = function () {
  return this.getClassExpData(/layout-id-(\d+)/);
};

Template.prototype.getFormatId = function () {
  return this.getClassExpData(/format-id-(\d+)/);
};

Template.prototype.getGridIndexInSet = function () {
  return this.getClassExpData(/grid-id-[\d+]-(\d+)/);
};

Template.prototype.getGridNumberOfPhotos = function () {
  return this.getClassExpData(/grid-id-(\d+)-[\d+]/);
};

Template.prototype.getRestrictedBasePage = function () {
  return this.getClassExpData(/base-page-(\d+)/);
};

Template.prototype.getClassExpData = function (exp) {
  var data;
  var $main = $(this.element).children('g.main');
  var classes = $main.attr('class');

  classes && _.any(classes.split(' '), function (className) {
    var match = className.match(exp);
    if (match) return data = match[1];
  });

  return data;
};
